module.exports = "/_next/static/images/4f755742645edc29af5006d7e84f75fb-background-lg.png.webp";